import { TOGGLE_SIDEBAR } from './actionType';

export const toggleSidebar = () => {
  return {
    type: TOGGLE_SIDEBAR
  }
}